<template>
  <van-col style="width: 100%; background-color: #f7f7f7;">
    <div class="remind-title">
      <div class="remind-line"></div>
      <div class="remind-text">配置提醒信息 </div>
    </div>

    <van-cell-group style="margin-top: 12px;">
      <van-cell v-for="(item, index) in list" :key="index" :border="true">
        <template #title>
          <div class="remind-tags">
            <div style="margin-right:12px;">提前</div>
            <van-stepper v-model="item.daysBefore" integer @change="onChange(item)" />
            <div style="margin-left:12px;">提醒</div>
          </div>
        </template>
        <template #right-icon>
          <van-switch v-model="item.isEnabled" size="24" @change="onChange(item)" />
        </template>
      </van-cell>
    </van-cell-group>

    <div class="footer" v-show="getPermission()">
      <van-button round type="info" @click="onClickAdd">添加营销模版</van-button>
    </div>

  </van-col>
</template>

<script>

import request from "@/utils/request";
import user from '@/utils/user'

export default {
  data() {
    return {
      duty: -1,
      list: [],
      reminerForm: {
        daysBefore: "",
        isEnabled: true,
      },
    };
  },
  created() {
    this.duty = user.getUserDuty()

    if (this.duty == 99) {
      //企业负责人
      this.onLoad()
    } else {
      this.$router.replace({ name: 'noPermission' });
    }

  },
  methods: {
    getPermission() {
      return this.duty == 99
    },
    onChange(item) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.onUpdateReminder(item)
      }, 500);
    },
    onClickAdd() {
      this.onAddReminder(1)
    },
    onLoad() {
      request.get("/Common/PredefinedReminder/GetConfig").then((res) => {
        this.list = res.data.data;
        if (this.list.length == 0) {
          this.onAddReminder(30)
          this.onAddReminder(15)
          this.onAddReminder(3)
        }
      }).catch(() => {
      });
    },
    onAddReminder(day) {
      this.reminerForm.daysBefore = day

      var filterForm = Object.assign({}, this.reminerForm);
      request.post("/Common/PredefinedReminder/Create", filterForm).then(() => {
        this.onLoad()
      }).catch(() => {
      });
    },
    onUpdateReminder(item) {
      var filterForm = Object.assign({}, item);
      request.post("/Common/PredefinedReminder/Update", filterForm).then(() => {
        this.onLoad()
      }).catch(() => {
      });
    },
  }
};
</script>

<style lang="less">
.remind-title {
  display: flex;
  background-color: #fff;
  padding: 12px;
  width: 100%;
}

.remind-line {
  background-color: #3a71ffff;
  border-radius: 4px;
  margin: 3px;
  width: 4px;
  height: 16px;
}

.remind-text {
  color: #333;
  margin-left: 6px;
}

.remind-tags {
  display: flex;
  align-items: center;
}

.footer {
  position: fixed;
  bottom: 62px;
  right: 12px;
  width: 100%;
  text-align: center;
  /* 如果你想让按钮居中 */
}
</style>
